import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";
import ReactExport from "react-export-excel";
import { validateRequiredFields } from "../../../utils/validation.util";
import { normalizeAmount } from "../../../utils/transformer.util";
import { Button, Select, SearchSelect } from "../../../components/base/index";

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class LaporanJP extends Component {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    // this._onAddList = this._onAddList.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._getClassesOptions = this._getClassesOptions.bind(this);
    this._handleFormChange = this._handleFormChange.bind(this);
    this._onSearch = this._onSearch.bind(this);
    this._onChangePage = this._onChangePage.bind(this);
    this.onClickCetak = this.onClickCetak.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._getTeacherScheduleOptions =
      this._getTeacherScheduleOptions.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._onClickExcel = this._onClickExcel.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._initializeData = this._initializeData.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._onClickSet = this._onClickSet.bind(this);
    this._getDayOptions = this._getDayOptions.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;
    this.state = {
      isTable: true,
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          total_siswa: "",
          classes: [],
          levels_id,
          listsiswa: [],
          classes_id: "",
          user_id: user.id,
          units_id: "",
          teacher_id: "",
        },
        error: {
          classes: "",
          levels: "",
          listsiswa: "",
        },
      },
      param: {},
      filtered: false,
      total_siswa: "",
    };
  }

  componentDidMount() {
    const {
      handleGetCodeOfAccount,
      location,
      handleGetClasses,
      handleGetLevels,
      user,
    } = this.props;
    const { school_unit, organizations_id, user_group } = user;
    const { content, filters, form } = this.state;

    let savedFilters =
      JSON.parse(window.localStorage.getItem("jadwalFilters")) || filters;
    let savedForm = JSON.parse(window.localStorage.getItem("jadwalForm")) || "";
    if (savedForm !== "" && user.id !== savedForm.value.user_id) {
      savedForm = "";
      savedFilters = filters;
    }
    this._initializeData(savedFilters);
    if (savedForm !== "") {
      this.setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            levels_id: savedForm.value.levels_id,
            units_id: savedForm.value.units_id,
            classes_id: savedForm.value.classes_id,
            // period: filters.period,
            // update: true,
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedForm.value.units_id,
        },
      }));
      this._getParamOptionsAcademics("classrooms", {
        levels_id: savedForm.value.levels_id,
        classes_id: savedForm.value.classes_id,
        units_id: savedForm.value.units_id.value,
        organizations_id,
      });

      if (
        user_group.name === "pusat" ||
        user_group.name === "perwakilan" ||
        user_group.name === "pengurus"
      ) {
        this._getClassesOptions({
          filters: {
            levels_id: savedForm.value.levels_id,
            units_id: savedForm.value.units_id.value,
          },
        });
        this._getPeriodsOptions({ units_id: savedForm.value.units_id.value });
        this._getTeacherScheduleOptions({
          units_id: savedForm.value.units_id.value,
        });
      }
    }
  }

  async _getDayOptions() {
    const { getDayOptions } = this.props;
    const res = await getDayOptions();
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        day: res,
      },
    }));
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const paramTypes = ["levels"];
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });

    if (user_group.name !== "pusat" || user_group.name === "pengurus") {
      this._getClassesOptions({
        filters: { levels_id: [levels_id], units_id: [school_unit.id] },
      });
      await this._getPeriodsOptions({ units_id: school_unit.id });
      await this._getTeacherScheduleOptions({ units_id: school_unit.id });
    }
    if (user_group.name === "perwakilan") {
      await this._getSchoolUnitsOptions({
        perwakilan_id: school_unit.perwakilan_id,
      });
    } else {
      await this._getSchoolUnitsOptions();
      // await this._getTeacherScheduleOptions();
    }
    await this._getDayOptions();
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          period: savedFilters.period,
          classrooms_id: savedFilters.classrooms_id,
          // savedFilters
        },
      }),
      () => {
        this._onSearchContent();
      }
    );
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find((item) => item.value === units_id);

    // console.log(units_id)
    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  onClickCetak() {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/laporan/daftar-siswa-kelas-unit", {
      isEdit: true,
    });
  }

  _onClickExcel() {
    const { history } = this.props;
    const { form, filters } = this.state;
    history.push(
      "/dashboard/kesiswaan/laporan/daftar-siswa-aktif/cetak-excel",
      {
        isEdit: true,
        data: {
          classes_id: form.value.classes_id,
          classrooms_id: filters.classrooms_id,
        },
      }
    );
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { school_unit, organizations_id } = user;
    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      // filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  // on formchange untuk form
  _handleFormChange(event) {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      form: {
        value: {
          ...prevState.form.value,
          [name]: value,
        },
        error: {
          ...prevState.form.error,
          [name]: "",
        },
      },
    }));
  }

  _onSearch() {
    const { form } = this.state;
    const error = validateRequiredFields(form.value, ["year"]);
    this.setState((prevState) => ({
      form: {
        value: prevState.form.value,
        error,
      },
    }));
    if (isEmpty(error)) {
      this.setState({ filtered: true });
    }
  }

  async _getParamOptions(type, filters = {}) {
    const { getParamOptions, user } = this.props;
    const { organizations_id } = user;
    if (type === "classes" || type === "classrooms") {
      filters.organizations_id = organizations_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptions(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _getClassesOptions(filters = {}) {
    const { getClassesOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    // if (user_group.name !== 'pusat'){

    // filters.levels_id = levels_id;
    // filters.units_id = school_unit.id;
    // }
    const res = await getClassesOptions(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        classes_prm: res,
      },
    }));
  }

  async _getTeacherScheduleOptions(filters = {}) {
    const { getTeacherScheduleOptions, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id, units_id } = school_unit;
    const res = await getTeacherScheduleOptions(filters);
    filters.units_id = units_id;
    // console.log(res)
    // console.log(res)
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        teacher: res,
      },
    }));
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions } = this.props;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              periods_id: data.value,
            },
          },
          filters: {
            ...prevState.filters,
            period: data.value,
            period_label: data.label,
          },
        }));
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  _onFormChange(event) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    // Store if we need to clear classrooms_id
    const shouldClearClassroomsId = name === "classes_id";

    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName];
          newListError = prevState.form.error[fieldName];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }

        // Create the new state object
        const newState = {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };

        // If we need to clear classrooms_id, add it to the filters
        if (shouldClearClassroomsId) {
          newState.filters = {
            ...prevState.filters,
            classrooms_id: "",
          };
        }

        return newState;
      },
      () => {
        if (name === "classes_id") {
          this._getParamOptionsAcademics("classrooms", {
            classes_id: value,
            organizations_id,
          });
        }
      }
    );
  }

  _onClickAdd() {
    const { form } = this.state;
    const { plafon } = form.value;

    plafon.push({
      tipePlafon: "",
      // divisi: '',
      nominal: 0,
      // period:'',
    });

    this.setState((prevState) => ({
      form: {
        value: {
          ...prevState.form.value,
          plafon,
        },
        error: {
          ...prevState.form.error,
        },
      },
    }));
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { subject_id, classrooms_id, period } = value;
    const { units_id, perwakilan_id } = filters;

    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const {
            handleReportSchedule,
            handleReportSchPerunit,
            handleReportSchPerwakilan,
            handleListScheduleTeacher,
            user,
          } = this.props;
          const { school_unit, workingUnit, id, user_group, organizations_id } =
            user;
          const { levels_id } = school_unit;
          const units =
            user_group.name === "pusat" ||
            user_group.name === "perwakilan" ||
            user_group.name === "pengurus"
              ? units_id.value
              : school_unit.id;

            const result = await handleListScheduleTeacher({
              ...params,
              organizations_id,
              units_id: units,
              period: filters.period,
              period_label: filters.period_label,
              filters,
            });
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listsiswa: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          console.log("masuk C");
          console.log(err);
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listsiswa: [],
              },
            },
          }));
        }
        // }
      }
    );
  }

  // on formchange untuk tabel
  onFormChange(event) {
    const { name, value, dataset } = event.target;
    const {
      inputArray = false,
      arrayPosition = 0,
      inputType = "text",
    } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      let newPlafon = [];
      if (inputType === "number") {
        formattedValue = normalizeAmount(value);
      }

      if (inputArray) {
        newPlafon = prevState.form.value.plafon;
        newPlafon[arrayPosition][name] = value;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { plafon: newPlafon }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            form: "",
            [name]: "",
          },
        },
      };
    });
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
        window.localStorage.setItem(
          "jadwalFilters",
          JSON.stringify(this.state.filters)
        );
        window.localStorage.setItem(
          "jadwalForm",
          JSON.stringify(this.state.form)
        );
       

        if (name === "units_id") {
          const param = this.state.param.units;
          const levels_units = param.find((i) => i.value === value.value)
            ? param.find((i) => i.value === value.value).attributes.levels_id
            : "";

          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                levels_id: levels_units,
                units_id: value,
              },
            },
            filters: {
              ...prevState.filters,
              period: "",
            },
          }));
          this._getParamOptionsAcademics("classrooms", {
            levels_id: levels_units,
            organizations_id,
            units_id: value.value,
          });
          this._getClassesOptions({
            filters: { levels_id: [levels_units], units_id: [value.value] },
          });

          this._getPeriodsOptions({ units_id: value.value });
          this._getTeacherScheduleOptions({ units_id: value.value });
        }

        if (name === "classes_id") {
          this._getParamOptionsAcademics("classrooms", {
            classes_id: value,
            organizations_id,
          });
        }

        this._onSearchContent();
      }
    );
  }

  _onClickSet() {
    const { form, filters } = this.state;
    const { value } = form;
    let error = {};;

    // if (isEmpty(error)) {
    this.setState(
      (prevState) => ({
        ...prevState,
        isTable: false,
        filters: {
          ...prevState.filters,
        },
      }),
      () => {
        this._onSearchContent();
      }
    );
  }
  // }

  _onChangePage(page) {
    const { listAmount, keywords } = this.state;
    const offset = listAmount * (page - 1);
    // this.handleGetData({
    this._onSearchContent({
      limit: listAmount,
      keywords,
      offset,
      page,
    });
  }

  _onClickNext() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      page: prevState.page + 1,
    }));
  }

  onClickEdit(val) {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/pendaftaran", {
      data: val,
      isEdit: true,
    });
  }

  _renderButtons(data) {
    const { user } = this.props;
    const { user_group } = user;
    const button = {};

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
        </div>
      </td>
    );
  }

  renderExcel(listsiswa) {
    const { form } = this.state;
    const { value } = form;

    const excelTbl = [];
    map(listsiswa, (list, idx) => {
      const items = Object.create({});
      items.name = list.name;
      items.unit_code = list.unit_code;
      items.total_student = list.total_student;

      excelTbl.push(items);
    });

    const rows = [];
    rows.push([
      form.value.units_id.value === "all" ? (
        <ExcelFile
          element={
            <Button style={{ height: 30, width: 400, marginRight: 9 }}>
              {" "}
              Ekspor Excel
            </Button>
          }
        >
          <ExcelSheet data={excelTbl} name="excel">
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Kelas"
              value="name"
            />
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Kode Unit"
              value="unit_code"
            />
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Jumlah Siswa"
              value="total_student"
            />
          </ExcelSheet>
        </ExcelFile>
      ) : (
        <ExcelFile
          element={
            <Button style={{ height: 30, width: 400, marginRight: 9 }}>
              {" "}
              Ekspor Excel
            </Button>
          }
        >
          <ExcelSheet data={excelTbl} name="excel">
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Kelas"
              value="name"
            />
            <ExcelColumn
              style={{ fontWeight: "bold" }}
              label="Jumlah Siswa"
              value="total_student"
            />
          </ExcelSheet>
        </ExcelFile>
      ),
    ]);
    return rows;
  }

  render() {
    const { param, form, filters, isTable } = this.state;
    const { listsiswa } = form.value;
    const { period, teacher_id, classes_id, classrooms_id, day_id } = filters;
    const { user } = this.props;
    const { school_unit, user_group } = user;

    const AllClasses = [{ value: "all", label: "Semua Tingkat Kelas", attributes: {} }];
    const AllClassrooms = [{ value: "all", label: "Semua Kelas", attributes: {} }];
    const AllDay = [{ value: "all", label: "Semua Hari", attributes: {} }];
    const AllTeacher = [{ value: "all", label: "Semua Guru", attributes: {} }];
    let total = 0;
    let totalres = 0;

    const componentRef = React.createRef();
    const printTest = `
    @media print {
      @page {
        page-break-inside: avoid;
      }
      * {
        -webkit-print-color-adjust: exact;
      }
    }`;

    const units_label = filters.units_id ? filters.units_id.label : "";
    const prm_period = param.periods ? param.periods : "";
    const prm_units = param.units ? param.units : "";
    const prm_teacher = param.teacher ? param.teacher : "";
    const prm_classrooms = param.classrooms ? param.classrooms : "";
    const prm_day = param.day ? param.day : "";
    const prm_classes = param.classes_prm ? param.classes_prm : "";
    const prm_perwakilan = param.perwakilan_prm ? param.perwakilan_prm : "";
    const period_label = prm_period
      ? prm_period.find((i) => i.value == period)
        ? prm_period.find((i) => i.value == period).label
        : ""
      : "";
    const teacher_all = [...AllTeacher, ...prm_teacher];
    const classrooms_all = [...AllClassrooms, ...prm_classrooms];
    const day_all = [...AllDay, ...prm_day];
    const classes_all = [...AllClasses, ...prm_classes];
    const years = [];
    const thisyear = new Date().getFullYear();
    for (let i = 2021; i <= thisyear; i++) {
      const nextyear = Number(i) + 1;
      years.push({
        label: `${i}-${nextyear}`,
        value: i,
      });
    }

    const period_label_all = years.find((i) => i.value == period)
      ? years.find((i) => i.value == period).label
      : "";
    return (
      <div className="manage-registration">
        <h1>Jadwal Mapel Guru</h1>
        <div className="absensi-rekap__custom-form">
          {user_group.name === "pusat" ||
          user_group.name === "perwakilan" ||
          user_group.name === "pengurus" ? (
            <div>
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <SearchSelect
                    noMargin
                    async={false}
                    name="units_id"
                    list={param.units}
                    inputArray
                    onClick={this._onChangeFilter}
                    placeholder="Pilih Unit"
                    value={form.value.units_id}
                    rightIcon="icon-search"
                    label="Pilih Unit"
                  />
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <Select
                name="period"
                label="Tahun Ajaran"
                onChange={this._onChangeFilter}
                data={param.periods}
                placeholder="Pilihan"
                value={period}
              />
            </div>
            <div className="absensi-rekap__custom-form-column__field">
              <SearchSelect
                noMargin
                async={false}
                name="teacher_id"
                label="Pilih Guru"
                onClick={this._onChangeFilter}
                list={teacher_all}
                inputArray
                placeholder={"Pilihan"}
                value={teacher_id}
                rightIcon="icon-search"
                isRequired
            />
            </div>
          </div>
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <Select
                name="classes_id"
                label="Tingkat Kelas"
                onChange={this._onChangeFilter}
                data={classes_all}
                placeholder="Pilihan"
                value={classes_id}
              />
              <div className="manage-registration__custom-form-row-datadiri">
                <Select
                  name="classrooms_id"
                  label="Kelas"
                  data={classrooms_all}
                  onChange={this._onChangeFilter}
                  placeholder="Pilihan"
                  value={classrooms_id}
                />
              </div>
            </div>
            <div className="absensi-rekap__custom-form-column__field">
              <Select
                type="text"
                name="day_id"
                label="Hari"
                onChange={this._onChangeFilter}
                data={day_all}
                value={day_id}
                placeholder={"Pilihan"}
              />
            </div>
          </div>
        </div>
        <div>
          <Button title="Proses" onClick={this._onClickSet} />
        </div>
        <br></br>
        <div className="beginning-balance__button-wrapper">
          <ReactToPrint
            pageStyle={printTest}
            onBeforeGetContent={() =>
              new Promise((resolve) => {
                setTimeout(() => {
                  this.setState({ isPrint: false }, resolve);
                }, 500);
              })
            }
            onAfterPrint={() => this.setState({ isPrint: true })}
            trigger={() => <Button title="Cetak" />}
            content={() => componentRef.current}
          />
          {/* <Button
              title="Ekspor Excel"
              onClick={this._onClickExcel}
            /> */}
          &nbsp;
          <div style={{ marginLeft: "0rem" }} className="student-list__button">
            <ReactHTMLTableToExcel
              id="export-to-xls-button"
              className="button "
              table="printable"
              filename={`Jumlah Siswa Semua Perwakilan Tahun ajaran ${period_label_all}`}
              sheet={period_label_all}
              buttonText="Unduh ke Excel"
            />
          </div>
        </div>
        {!isTable && (
          <form
            style={{ pageBreakInside: "avoid", paddingTop: "20px" }}
            ref={componentRef}
          >
            <div className="manage-registration">
              <table
                className="laporan-ki4__table-test"
                style={{ width: "unset" }}
              ></table>
              <div className="fund-request__content">
           
                {form.value.units_id.value !== "all" && (
                  <table
                    className="table"
                    id="printable"
                    ref={componentRef}
                    style={{ textAlign: "center" }}
                  >
                    <thead>
                      <tr className="grey">
                        <th>Kode Guru</th>
                        <th>NIP</th>
                        <th>Nama</th>
                        <th>Kelas</th>
                        <th>Hari</th>
                        <th>Jam</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listsiswa.length > 0 ? (
                        <>
                          {map(listsiswa, (list, listIdx) => {
                            console.log(list.details);
                            const hasDetail =
                              list.details &&
                              Array.isArray(list.details) &&
                              list.details.length > 0;

                            const detailCount = hasDetail
                              ? list.details.length
                              : 1;

                            const totalJP = hasDetail
                              ? list.details.reduce(
                                  (s, d) => s + Number(d.ttl_mapel || 0),
                                  0
                                )
                              : 0;

                            const rowSpan = Math.max(detailCount, 1);
                            const firstDetail =
                              hasDetail &&
                              list.details[0] &&
                              list.details[0].mapel_name
                                ? list.details[0]
                                : null;
                            return (
                              <React.Fragment key={`${listIdx}`}>
                                <tr>
                                  <td rowSpan={rowSpan}>{list.code}</td>
                                  <td rowSpan={rowSpan}>{list.nip}</td>
                                  <td rowSpan={rowSpan}>{list.nama_lengkap}</td>
                                 
                                  {/* ROW PERTAMA */}
                                  <td>
                                    {firstDetail ? firstDetail.classrooms_name : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.day_name : "-"}
                                  </td>
                                  <td>
                                    {firstDetail ? firstDetail.hour : "-"}
                                  </td>
                                  {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                  {/* <td
                                    rowSpan={detailCount}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {totalJP || "-"}
                                  </td> */}
                                </tr>

                                {/* MAPEL LANJUTAN */}
                                {hasDetail &&
                                  list.details.slice(1).map((dtl, i) =>
                                    dtl && dtl.mapel_name ? (
                                      <tr key={i}>
                                        <td>{dtl.classrooms_name}</td>
                                        <td>{dtl.day_name}</td>
                                        <td>{dtl.hour}</td>
                                      </tr>
                                    ) : null
                                  )}
                              </React.Fragment>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={10}>Data Belum Ada</td>
                        </tr>
                      )}
                    </tbody>
                    {/* {listsiswa.length > 0 ? (
                      // Calculate total classes for this perwakilan
                      map(listsiswa, (list, idx) => (
                        <>
                          <tbody>
                            <tr key={`budget_row_${idx}`}>
                              <td>{list.code}</td>
                              <td>{list.staff_nip}</td>
                              <td>{list.staff_name}</td>
                              <td>{list.position_name}</td>
                              <td>{list.jp}</td>
                              <td>{list.wajib_mengajar}</td>
                              <td>{list.kelmeng}</td>
                              {list.details.length > 0
                                ? map(list.details, (dtl, idx) => (
                                    <>
                                      <td>{dtl.mapel_name}</td>
                                      <td>{dtl.ttl_mapel}</td>
                                    </>
                                  ))
                                : ""}
                            </tr>
                          </tbody>
                        </>
                      ))
                    ) : (
                      <td colSpan={7}>Data Belum Ada</td>
                    )} */}
                  </table>
                )}
              </div>
            </div>
          </form>
        )}
      </div>
    );
  }
}
LaporanJP.propTypes = {
  user: PropTypes.object.isRequired,
  handleGetCodeOfAccount: PropTypes.func,
  location: PropTypes.object,
  handleGetClasses: PropTypes.func,
  handleGetLevels: PropTypes.func,
  getSchoolUnitsOptions: PropTypes.func.isRequired,
  getParamOptionsAcademics: PropTypes.func.isRequired,
  getClassesOptions: PropTypes.func.isRequired,
  getPeriodsOptions: PropTypes.func.isRequired,
  handleReportSchedule: PropTypes.func.isRequired,
  handleReportSchPerunit: PropTypes.func.isRequired,
  handleReportSchPerwakilan: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  classes: PropTypes.object,
  levels: PropTypes.object,
};

LaporanJP.defaultProps = {
  handleGetCodeOfAccount: noop,
  location: {},
  handleGetClasses: noop,
  handleGetLevels: noop,
  classes: {},
  levels: {},
};
